import {
  AlertCircle,
  CheckCircle2,
  Clock,
  FileCheck,
  FileText,
  Send,
  Wallet,
  XCircle,
} from 'lucide-react';

import { Badge } from '@/ui/base/badge';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/ui/base/tooltip';

const ICONE: Record<string, typeof Clock> = {
  RASCUNHO: Clock,
  PROCESSADA: FileText,
  APROVADA: FileCheck,
  EXPORTADA_SOF: Send,
  CONFIRMADO_SOF: CheckCircle2,
  REJEITADA: XCircle,
  PAGA: Wallet,
};

const ROTULO: Record<string, string> = {
  RASCUNHO: 'Rascunho',
  PROCESSADA: 'Processada',
  APROVADA: 'Aprovada',
  EXPORTADA_SOF: 'No SOF',
  CONFIRMADO_SOF: 'Confirmada pelo SOF',
  REJEITADA: 'Rejeitada',
  PAGA: 'Paga',
};

const TOM: Record<string, string> = {
  RASCUNHO: 'border-border text-muted-foreground',
  PROCESSADA: 'border-border text-muted-foreground',
  APROVADA: 'border-primary/40 text-primary bg-primary/10',
  EXPORTADA_SOF: 'border-primary/40 text-primary bg-primary/10',
  CONFIRMADO_SOF: 'border-success/40 text-success bg-success/10',
  REJEITADA: 'border-destructive/40 text-destructive bg-destructive/10',
  PAGA: 'border-success/40 text-success bg-success/10',
};

const DICA: Record<string, string> = {
  RASCUNHO: 'Medição ainda não processada.',
  PROCESSADA: 'Medição processada. Aguardando aprovação.',
  APROVADA: 'Medição aprovada. Aguardando emissão do empenho.',
  EXPORTADA_SOF: 'Lote exportado ao SOF (modo simulação).',
  CONFIRMADO_SOF: 'Lote confirmado pelo SOF. Pagamento programado.',
  REJEITADA: 'Lote rejeitado pelo SOF. Verifique o motivo no detalhe da medição.',
  PAGA: 'Pagamento liquidado.',
};

/** FIN-031: selo de estágio SOF, reaproveitado em Status e Conciliação —
 * mesmo componente do protótipo (`SofStatusBadge.tsx`). */
export function EstagioSofBadge({
  estagio,
  semTooltip,
}: {
  estagio: string | undefined;
  semTooltip?: boolean;
}) {
  if (!estagio) {
    return (
      <Badge variant="outline" className="gap-1 text-xs">
        <AlertCircle className="h-3 w-3" aria-hidden="true" /> sem dado
      </Badge>
    );
  }
  const Icon = ICONE[estagio] ?? Clock;
  const badge = (
    <Badge
      variant="outline"
      className={`gap-1 text-xs font-medium ${TOM[estagio] ?? 'border-border text-muted-foreground'}`}
    >
      <Icon className="h-3 w-3" aria-hidden="true" />
      {ROTULO[estagio] ?? estagio}
    </Badge>
  );
  if (semTooltip) return badge;
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span>{badge}</span>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs text-xs">{DICA[estagio] ?? estagio}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
